/** Institution usage calls (STORY-100), served by the analytics service from its projections.
 * Aggregates only: nothing here ever carries a respondent id, a subject or a name. */
import { get, post } from "../api/client";
import type { CourseUsageOut, InstitutionRow, InstitutionUsage } from "./usage";

export { defaultRange, monthLabel, monthOf, monthRange, pct, seriesMax, usageCsv } from "./usage";
export type { BandTotals, CourseUsageOut, CourseUsageRow, InstitutionRow, InstitutionUsage, MonthRange, UsageMonth, UsageTotals } from "./usage";

const range = (from: string, to: string) => `from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;

export const listUsageInstitutions = () => get<InstitutionRow[]>("/analytics/v1/institutions");
export const getInstitutionUsage = (id: string, from: string, to: string) =>
  get<InstitutionUsage>(`/analytics/v1/institutions/${id}/usage?${range(from, to)}`);
export const getCourseUsage = (id: string, from: string, to: string) =>
  get<CourseUsageOut>(`/analytics/v1/institutions/${id}/courses?${range(from, to)}`);
export const refreshInstitutionUsage = (id: string, from: string, to: string) =>
  post<{ institution_id: string; months: string[] }>(`/analytics/v1/institutions/${id}/usage/refresh?${range(from, to)}`);
